<template>
    <div style="width:100%;">
          <Loading :value="loading" ></Loading>
            <v-layout row>
                <v-flex xs4 mt-2 mb-2 mr-2 ml-2 >
                     <v-card   color="cyan darken-2" class="white--text elevation-5">
                        <v-container fluid grid-list-lg>
                                        <v-layout row>
                                        <v-flex xs8>
                                            <div>
                                            <div class="display-3">{{coutPrevu}}</div>
                                            <div>Coût prévisionnel (Budget validé)</div>
                                            </div>
                                        </v-flex>
                                         <v-flex xs4>
                                            <div></div>
                                            <div class="display-3"></div>
                                        </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card>
                </v-flex>

                 <v-flex xs4  mt-2 mb-2 mr-2 ml-2  >
                    <v-card   color="green darken-2" class="white--text elevation-5">
                        <v-container fluid grid-list-lg>
                                        <v-layout row>
                                        <v-flex xs8>
                                            <div>
                                            <div class="display-3">{{coutActuel}}</div>
                                            <div>Coût actuel</div>
                                            </div>
                                        </v-flex>
                                         <v-flex xs4>
                                            <div></div>
                                            <div class="display-3"></div>
                                        </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card>
                </v-flex>

               

                <v-flex xs4  mt-2 mb-2 mr-2 ml-2  >
                     <v-card   color="light-blue darken-2" class="white--text elevation-5">
                                    <v-container fluid grid-list-lg>
                                        <v-layout row>
                                        <v-flex xs6>
                                            <div>
                                            <div class="headline">{{nbOuvrier}}</div>
                                            <div>Contrat(s) ouvrier(s)</div>
                                            </div>
                                        </v-flex>
                                        <v-flex xs6>
                                            
                                            <div class="display-3">{{nbPrestataire}}</div>
                                            <div>Contrat(s) prestataire(s)</div>
                                        </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card>
                </v-flex>
        </v-layout>

        <v-layout row>
             
               

                <v-flex xs4  mt-2 mb-2 mr-2 ml-2  >
                     <v-card   color="purple darken-2" class="white--text elevation-5">
                                    <v-container fluid grid-list-lg>
                                        <v-layout row>
                                        <v-flex xs8>
                                            <div>
                                                <div class="display-3">{{tauxExec}}</div>
                                            <div>Taux exécution chronogramme (chantier terminé) (%)</div>
                                            </div>
                                        </v-flex>
                                        <v-flex xs4>
                                            <div></div>
                                            <div class="display-3"></div>
                                        </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card>
                </v-flex>

            <v-flex xs4  mt-2 mb-2 mr-2 ml-2  style="text-align:center">
                <p>
                    <b>Taux evolution projet</b>
                </p>
                <v-progress-circular
                        :size="190"
                        :width="30"
                        :rotate="360"
                        :value="projet.evolution"
                        color="red"
                >{{projet.evolutionNbr}} %</v-progress-circular>
            </v-flex>

                <v-flex xs4  mt-2 mb-2 mr-2 ml-2  >
                         <v-card   color="orange darken-2" class="white--text elevation-5">
                                    <v-container fluid grid-list-lg>
                                        <v-layout row>
                                        <v-flex xs7>
                                            <div>
                                                <div class="headline">{{nbChantTermine}}</div>
                                                <div>Chantier(s) Terminé(s)</div>
                                            </div>
                                             <div>
                                                <div class="headline">{{nbChantArret}}</div>
                                                <div>Chantier(s) Arreté(s)</div>
                                            </div>
                                             <div>
                                                <div class="headline">{{nbChantEnCours}}</div>
                                                <div>Chantier(s) (en cours)</div>
                                            </div>
                                        </v-flex>
                                        <v-flex xs5>
                                            <div class="display-3">{{nbChant}} </div>
                                            <div>Total chantier(s)</div>
                                            
                                        </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card>
                </v-flex>


                
               
        </v-layout>
    </div>
</template>

<script>
var echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/bar");
require("echarts/lib/chart/pictorialBar");
require("echarts/lib/chart/funnel");
require("echarts/lib/chart/sankey");
require("echarts/lib/chart/scatter");
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
import html2canvas from "html2canvas";

import Loading from "@/components/Loading";


export default {
  components: { Loading },
  name: "WidgetProjet",
  props: {
    show: {
      type: Boolean
    },
    type:{
        type:Number,
        default: 0
    },
    projet: {
      type: Object
    }
  },
  data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem('userInfo')),
      loading: false,

       statusRapport: [],
       coutPrevu:0,
       coutActuel:0,
       nbOuvrier:0,
       nbPrestataire: 0,
       nbChantTermine:0,
       nbChantArret:0,
       nbChantEnCours: 0,
       nbChant: 0,
       tauxExec:0
      

      
    };
  },

  watch: {
   
  },
   

  methods: {
      loadStatChant(){
        let url = this.domaine + "projet/stat/"+this.projet.id;

        this.$http.get(url).then( (response)=>{
        this.loading = false;
        console.log("stat chantier projet",response.body )
        this.coutPrevu = response.body.coutPrevu;
        this.coutActuel = response.body.coutActuel;
        this.nbOuvrier = response.body.nbOuvrier;
        this.nbPrestataire = response.body.nbPrestataire;
        this.nbChantTermine = response.body.nbChantTermine;
        this.nbChantArret = response.body.nbChantArret; 
        this.nbChantEnCours = response.body.nbChantEnCours; 
        this.nbChant = response.body.nbChant; 
        this.tauxExec = response.body.tauxExec; 
       }, (error)=>{
            this.loading = false;
            this.$message.error(
                "Erreur lors chargement projet dashboard"
            );
        } )
    }
  },
  
  watch: {
      projet: function(newValue, oldValue){
             this.loadStatChant()
      }
  },


  mounted() {
   
  }
};
</script>


// WEBPACK FOOTER //
// src/components/boardProjet/widgetProjet.vue